export default __webpack_public_path__ + "static/media/Kathy Watanabe.a2220572.jpg";